<template>
  <div class="reg">
    <div class='reg-wrapper'>
      <form id='reg-form' role="form" @submit="submit">
        <h4 class="form-signin-heading">{{ header }}</h4>
        <template v-if='stage == 1'>
          <div class="row">
            <div class="col-md-3 text-right top-offset">Фамилия</div>
            <div class="col-md-9"><input v-model="user.f_93" type="text" class="form-control reg-control"></input></div>
          </div>

          <div class="row">
            <div class="col-md-3 text-right top-offset">Имя</div>
            <div class="col-md-9">  <input v-model="user.f_94" type="text" class="form-control reg-control"></input></div>
          </div>

          <div class="row">
            <div class="col-md-3 text-right top-offset">Отчество</div>
            <div class="col-md-9"><input v-model="user.f_95" type="text" class="form-control reg-control"></input></div>
          </div>
          <br/>

          <div class="row">
            <div class="col-md-3 text-right top-offset">Организация</div>
            <div class="col-md-9"><reg-organization :id='user.f_96'></reg-organization></div>
          </div>

          <template v-if='user.f_96 == 1'>
            <div class="row">
              <div class="col-md-3 text-right top-offset">Филиал</div>
              <div class="col-md-9"><reg-organization-property org_id='1' key='1' :id='user.f_97'></reg-organization-property></div>
            </div>

            <!-- <div class="row">
              <div class="col-md-3 text-right">Логин</div>
              <div class="col-md-9"><input v-model="user.login" type="text" class="form-control reg-control"></input></div>
            </div> -->

          </template>

          <template v-if='user.f_96 == 2'>
            <div class="row">
              <div class="col-md-3 text-right top-offset">ФО</div>
              <div class="col-md-9"><reg-organization-property org_id='2' key='2' :id='user.f_97'></reg-organization-property></div>
            </div>
          </template>

          <div class="row">
            <div class="col-md-3 text-right top-offset">Должность</div>
            <div class="col-md-9"><input v-model="user.f_98" type="text" class="form-control reg-control"></input></div>
          </div>

          <div class="row">
            <div class="col-md-3 text-right top-offset">Email</div>
            <div class="col-md-9"><input v-model="user.f_100" type="text" class="form-control reg-control" placeholder="example@example.com"></input></div>
          </div>      

          <div class="row">
            <div class="col-md-3 text-right top-offset">Дополнительные контакты</div>
            <div class="col-md-9"><input v-model="user.f_99" type="text" class="form-control reg-control"></input></div>
          </div>     
        </template>

        <template v-if='stage == 2'>
          <div class="row" style="margin-bottom: 15px;">
            <div class="col-sm-12">
              <table class="dateTable">
                <thead>
                  <tr>
                    <th>Название модуля</th>
                    <th>Может редактировать</th>
                    <th>Может редактировать всё</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for='(unit, index) in units' :key='unit.id'>
                    <td>{{ unit.name }}</td>
                    <td><input type='checkbox' @change='canUpdateUnitChange(index, $event.target.checked)' :checked='units[index].state !== null'/></td>
                    <td><input type='checkbox' @change='canAdministrateUnitChange(index, $event.target.checked)' :disabled='disabledBox(index)' :checked='units[index].state === true'/></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>

        <template v-if='stage == 3'>
          <div class="row" style="margin-bottom: 15px;">
            <div class="col-sm-12">
              <table class="dateTable">
                <thead>
                  <tr>
                    <th>Название отчёта</th>
                    <th>Может просматривать</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for='(report, index) in reports' :key='report.id'>
                    <td>{{ report.name }}</td>
                    <td><input type='checkbox' @change='canVievReportChange(index, $event.target.checked)' :checked='reports[index].state == true'/></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>

        <div class="row">
          <div class="col-sm-12">
            <button v-if='stage > 1' @click='stage = stage - 1' type="button" class='btn btn-primary btn-color'>Назад</button>
            <button @click='nextStage()' type="button" class='btn btn-primary btn-color pull-right' :disabled='disableButton'>{{ button_label }}</button>
            <button @click='cancel()' type="button" class='btn btn-secondary pull-right' style='margin-right: 10px;'>Отмена</button>
          </div>
        </div>
      </form>
    </div>

    <modal title='' v-model="showErrorModal" @ok="showErrorModal = false" :backdrop='false' medium>
      <div style="margin-bottom: 5px; font-size: 120%;">
        <span>Был автоматически сгенерирован логин</span> <span class="new_login">{{ double_login }}</span>
      </div>
      <div style="margin-bottom: 5px; font-size: 120%;">
        <span>Этот логин уже занят пользователем</span> <span class="new_login">{{ double_user }}</span><br>
      </div>
      <div style="font-size: 120%;">
        <span>Для регистрации обратитесь к администратору</span>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-primary" @click='showErrorModal = false'>Ок</button>
      </div>
    </modal>

    <modal title='' v-model="showRegModal" @ok="showRegModal = false" :backdrop='false' small>
      <div style="margin-bottom: 15px; font-size: 120%;">
        <span style="width: 65px; display: inline-block;">Логин:</span> <span class="new_login">{{ new_login }}</span>
      </div>
      <div style="font-size: 120%;">
        <span style="width: 65px; display: inline-block;">Пароль:</span> <span class="new_login">{{ new_pass }}</span>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-primary" @click='showRegModal = false'>Ок</button>
      </div>
    </modal>

  </div>
</template>

<script>
  import auth from '../../auth'
  import router from '../../router'
  import regOrganization from './organization'
  import regOrganizationProperty from './organizationProperty'

  import { modal } from 'vue-strap'

  import {EventBus} from './../../lib/EventBus'
  import {DB} from './../../constants'

  const REG = 'reg_new_user.php'
  const USER_ID = 'get_user_id.php'
  const UNITS = 'get_units.php'
  const REPORTS = 'get_reports.php'

  export default {
    data () {
      return {
        user: {
          f_93: '',//f
          f_94: '',//i
          f_95: '',//o
          f_96: '',//org_id
          f_97: '',//org_loc_id
          f_98: '',//post
          f_99: '', //contacts
          f_100: '', //email
          f_108: '',
          f_109: ''
        },
        stage: 1,
        showRegModal: false,
        showErrorModal: false,
        new_login: null,
        new_pass: null,
        double_login: null,
        double_user: null,
        units: [],
        reports: [],
        rights: []
      }
    },
    computed: {
      header: function () {
        if(this.stage == 1)
          return 'Регистрация нового пользователя'
        else
          return 'Укажите права пользователя'
      },
      button_label: function () {
        if(this.stage == 3)
          return 'Регистрация'
        else
          return 'Продолжить'
      },
      disableButton: function () {
        if(this.stage == 1)
          if(this.user.f_93.length && 
            this.user.f_94.length && 
            this.user.f_95.length && 
            this.user.f_96 != '0' && 
            this.user.f_97 != '0' && 
            this.user.f_98.length &&
            this.user.f_100.length &&
            /\S+@\S+\.\S+/.test(this.user.f_100))
            return false

        if(this.stage == 2 || this.stage == 3)
          return false

        return true
      }
    },
    methods: {
      cancel: function() {
        router.replace('/main')
      },
      disabledBox: function (id) {
        if(this.units[id].state === null)
          return true
        else
          return false
      },
      canUpdateUnitChange: function(id, value) {
        if(value)
          this.units[id].state = false
        else
          this.units[id].state = null
        this.$forceUpdate()
      },
      canAdministrateUnitChange: function(id, value) {
        this.units[id].state = value
        this.$forceUpdate()
      },
      canVievReportChange: function(id, value) {
        this.reports[id].state = value
      },
      nextStage: function () {
        if(this.stage == 1)
        {
          let data = new FormData()

          data.append('json', JSON.stringify(this.user))

          fetch(DB + USER_ID, {
            method: 'POST',
            body: data,
            credentials: 'include'
          })
          .then(result => result.json())
          .then(result => {
            if(result.id != -1)
            {
              this.showErrorModal = true
              this.double_user = result.name
              this.double_login = result.login
            }
            else
            {
              this.stage++
              return
            }
          })
          .catch(e => {
            console.log(e)
          })
        }
        if(this.stage == 2)
        {
          this.stage++
          return
        }
        if(this.stage == 3)
        {
          let units_obj = ''
          for(let i in this.units)
            if(this.units[i].state == true || this.units[i].state == false)
              units_obj += ('{' + this.units[i].id + ',' + this.units[i].state + '},')
          units_obj = '{' + units_obj.substring(0, units_obj.length - 1) + '}'
          this.user.f_109 = units_obj

          let reports_obj = ''
          for(let i in this.reports)
            if(this.reports[i].state)
              reports_obj += ( this.reports[i].id + ',')
          reports_obj = '{' + reports_obj.substring(0, reports_obj.length - 1) + '}'
          this.user.f_108 = reports_obj
          
          this.submit()
          //console.warn(reports_obj)
        }

      },
      submit: function () {
        var data = new FormData()

        data.append('json', JSON.stringify(this.user))

        fetch(DB + REG, {
          method: 'POST',
          body: data,
          credentials: 'include'
        })
        .then(result => result.json())
        .then(result => {
          if(result.error_code)
          {
            window.alert('Ошибка во время регистрации пользователя')
            console.warn(result.error_code)
          }
          else
          {
            this.new_login = result.login
            this.new_pass = result.password
            this.showRegModal = true
          }
        })
        .catch(e => {
          console.log(e)
        })
      }
    },
    created () {

      if(!this.$parent.can_reg_user)
        router.replace('/main')

      EventBus.$on('reg-organization', id => {
        this.user.f_96 = id
        this.user.f_99 = ''
      })
      EventBus.$on('reg-organization-property', id => {
        this.user.f_97 = id
      })

      fetch(DB + UNITS, {
          credentials: 'include'
        })
        .then(result => result.json())
        .then(result => {
          if(result)
          {
            this.units = result
            for(let i in this.units)
              this.units[i].state = null
          }
        })
        .catch(e => {
          console.log(e)
        })

        fetch(DB + REPORTS, {
          credentials: 'include'
        })
        .then(result => result.json())
        .then(result => {
          if(result)
          {
            this.reports = result
            for(let i in this.reports)
              this.reports[i].state = true
          }
        })
        .catch(e => {
          console.log(e)
        })

    },
    components: {
      alert,
      regOrganization,
      regOrganizationProperty,
      modal
    }
  }

</script>

<style scoped>
  .reg-control {
    width: 100%;
  }

  #reg-form {
    width: 600px;
    margin: 0 auto;
    border: 2px solid #337ab7;
    padding: 10px;
    border-radius: 4px;
  }

  .new_login {
    padding: 2px 5px;
    font-weight: bold;
    border: 1px solid lightgray;
    background-color: #f5f5f5;
    border-radius: 4px;
  }

  .form-control {
    height: 26px;
    padding: 4px 12px;
  }

  .top-offset {
    position: relative;
    top: 3px;
  }
</style>



// WEBPACK FOOTER //
// Reg.vue?0d57a9b6